import { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';

export const SectionTitle: FunctionComponent<{ children: string }> = ({
    children,
}) => (
    <Box
        sx={{
            backgroundColor: 'grey.300',
            p: 2,
            borderRadius: 1,
            mb: 3,
        }}
    >
        <Typography variant='subtitle1' fontWeight={600}>
            {children}
        </Typography>
    </Box>
);
